import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import VueClickAway from "vue3-click-away";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faAdd, faTrash, faEye, faEyeSlash, faPenToSquare, faArrowLeft, faArrowRight, faChartSimple, faFloppyDisk, faDownload, faHome, faList, faTableCellsLarge, faUser, faQuestionCircle, faAnglesLeft, faAnglesRight, faRightToBracket, faRightFromBracket, faBook, faCog, faBars, faCircleInfo, faAngleUp, faAngleDown, faTimes, faUpload, faCircleNotch, faFileImport, faFileExport, faEllipsis, faLink, faGlobe, faStickyNote, faArrowRightArrowLeft, faCopy, faPaste, faBriefcase, faUsers, faDownLeftAndUpRightToCenter, faUserSecret, faUserTie, faBuilding, faComment, faRotate, faAt, faFolder, faThumbTack, faSearch, faForward, faPlay, faStrikethrough, faEnvelope, faSitemap, faFlag, faUnlink, faCircleHalfStroke, faClipboard, faCheck, faPuzzlePiece, faSort, faChevronLeft, faChevronRight, faFileContract, faCookieBite, faClockRotateLeft, faRefresh, faFilter, faAngleLeft, faAngleRight, faAnglesDown, faAnglesUp, faExternalLinkAlt, faArrowUpRightFromSquare, faCodeCompare, faChevronDown, faChevronUp, faQuestion, faExclamationTriangle, faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { faStickyNote as faStickyNoteRegular, faCopy as faCopyRegular } from '@fortawesome/free-regular-svg-icons';
import NotificationContainer from './components/NotificationContainer.vue';
import PrimeVue from "primevue/config";
import Aura from '@primeuix/themes/aura';
import '@imengyu/vue3-context-menu/lib/vue3-context-menu.css';
import { setupKanjiVariantToggle } from './utils/kanjiVariantToggle';

library.add(faAdd, faTrash, faEye, faEyeSlash, faPenToSquare, faArrowLeft, faArrowRight, faChartSimple, faFloppyDisk, faDownload, faHome, faList, faTableCellsLarge, faUser, faQuestionCircle, faAnglesLeft, faAnglesRight, faChevronLeft, faChevronRight, faChevronDown, faChevronUp, faRightToBracket, faRightFromBracket, faBook, faCog, faBars, faCircleInfo, faAngleUp, faAngleDown, faAnglesUp, faAnglesDown, faAngleLeft, faAngleRight, faTimes, faUpload, faCircleNotch, faFileImport, faFileExport, faEllipsis, faLink, faGlobe, faStickyNote, faStickyNoteRegular, faArrowRightArrowLeft, faCopy, faPaste, faCopyRegular, faBriefcase, faUsers, faDownLeftAndUpRightToCenter, faUserSecret, faUserTie, faBuilding, faComment, faRotate, faAt, faFolder, faThumbTack, faSearch, faForward, faPlay, faStrikethrough, faEnvelope, faSitemap, faFlag, faUnlink, faCircleHalfStroke, faClipboard, faCheck, faPuzzlePiece, faSort, faFileContract, faCookieBite, faClockRotateLeft, faRefresh, faFilter, faExternalLinkAlt, faArrowUpRightFromSquare, faCodeCompare, faQuestion, faExclamationTriangle, faCalendarDays);

import './assets/main.css';
// import { headerCell } from '@primeuix/themes/aura/datatable';

store.commit('initThemeMode');

setupKanjiVariantToggle();

if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
        store.commit('syncSystemTheme');
    });
}

const app = createApp(App)
    .use(router)
    .use(store)
    .use(i18n)
    .use(VueClickAway)
    // .use(PrimeVue, {unstyled: true})
    .use(PrimeVue, {
        theme: {
            preset: Aura,
            options: {
                darkModeSelector: '.dark',
            },
            cssVars: {
                cssVars: {
                    '--p-button-text-secondary-color': '#ff0000', // Replace with your color
                },
            },
        },
        pt: {
            column: {
                headerCell: {
                    class: '!bg-keyframe-500 !text-white !hover:bg-keyframe-400'
                },
            }
        },
    })
    .component('font-awesome-icon', FontAwesomeIcon)
    .component('notification-container', NotificationContainer);

app.mount('#app');
